__turbopack_context__.v({
  "className": "space_grotesk_b0b72f2-module__57RtGa__className",
  "variable": "space_grotesk_b0b72f2-module__57RtGa__variable",
});
